package org.gstechnovos.jexonplastech.sections.product_details.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.dom.ref
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.gstechnovos.jexonplastech.util.animateSlideUp
import org.gstechnovos.jexonplastech.util.rememberScrollVisibility
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun ProductDescriptionSection(description: String) {
    val palette = ColorMode.current.toSitePalette()
    val (isVisible, visibilityRef) = rememberScrollVisibility(threshold = 0.1)

    Div(
        attrs = Modifier.fillMaxWidth().display(DisplayStyle.Flex).flexDirection(FlexDirection.Column)
            .alignItems(com.varabyte.kobweb.compose.css.AlignItems.Center)
            .toAttrs {
                ref { element ->
                    visibilityRef(element)
                    onDispose {}
                }
            }) {
        Column(
            modifier = Modifier.fillMaxWidth().maxWidth(1200.px).padding(leftRight = 5.percent, topBottom = 20.px)
                .animateSlideUp(isVisible, delayMs = 150)
        ) {
            SpanText(
                text = "Description",
                modifier = Modifier.fontSize(24.px).fontWeight(FontWeight.Bold).color(palette.custom.darkText)
                    .margin(bottom = 16.px)
            )

            // Description box with a stylish brand accent line on the left
            Column(
                modifier = Modifier.fillMaxWidth().backgroundColor(palette.custom.lightGray.toRgb().copyf(alpha = 0.3f))
                    .borderRadius(topRight = 8.px, bottomRight = 8.px)
                    .borderLeft(width = 4.px, style = LineStyle.Solid, color = palette.brand.primaryBlue).padding(24.px)
            ) {
                SpanText(
                    text = description,
                    modifier = Modifier.fontSize(16.px).lineHeight(1.7)
                        .color(palette.custom.darkText.toRgb().copyf(alpha = 0.85f))
                )
            }
        }
    }
}